<template>
    <div class="productMenuBlock">
        <div class="product-category-content-wrapper">
            <div class="row">
                <div class="col-lg-12 dis-flex mb-4 p-lr-0-sm element-forms-selecting desctop-options-menu">
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'productList'" :class="{'active-btn': selectedMenu == 'productList'}">
                        <i class="fa fa-folder-open mr-2"></i>products
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createProductAttributes'" :class="{'active-btn': selectedMenu == 'createProductAttributes'}">
                        <i class="uis uis-brightness-plus mr-2"></i>attributes
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createNewProduct'" :class="{'active-btn': selectedMenu == 'createNewProduct'}">
                        <i class="uis uis-create-dashboard mr-2"></i>new product
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'brandMenu'" :class="{'active-btn': selectedMenu == 'brandMenu'}">
                        <i class="fa fa-trademark mr-2"></i>Brand
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'deleteProductFormList'" :class="{'active-btn': selectedMenu == 'deleteProductFormList'}">
                        <i class="uis uis-trash-alt mr-2"></i>delete products
                    </button>
                </div>

                <div class="col-lg-12 mb-4 p-lr-0-sm element-forms-selecting mobile-options-menu">
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'productList'" :class="{'active-btn': selectedMenu == 'productList'}" attr="products">
                        <i class="fa fa-folder-open"></i>
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createProductAttributes'" :class="{'active-btn': selectedMenu == 'createProductAttributes'}" attr="attributes">
                        <i class="uis uis-brightness-plus"></i>
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'createNewProduct'" :class="{'active-btn': selectedMenu == 'createNewProduct'}" attr="new product">
                        <i class="uis uis-create-dashboard"></i>
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'brandMenu'" :class="{'active-btn': selectedMenu == 'brandMenu'}" attr="brand">
                        <i class="fa fa-trademark"></i>
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'deleteProductFormList'" :class="{'active-btn': selectedMenu == 'deleteProductFormList'}" attr="delete products">
                        <i class="uis uis-trash-alt"></i>
                    </button>
                </div>
            </div>

            <product-list v-if="selectedMenu == 'productList'"
                v-model:selectedMenu="selectedMenu"
                v-model:selectedProductForOverview="selectedProductGroupForOverview"
                v-model:selectedProductForEdit="selectedProductForEdit"></product-list>
            <product-attributes v-else-if="selectedMenu == 'createProductAttributes'"></product-attributes>
            <create-new-prod-block v-else-if="selectedMenu == 'createNewProduct'"></create-new-prod-block>
            <product-list-item-edit v-else-if="selectedProductForEdit"></product-list-item-edit>
            <product-group-overview v-else-if="selectedProductGroupForOverview"
                v-model:selectedMenu="selectedMenu"
                v-model:selectedProductForEdit="selectedProductForEdit"></product-group-overview>
        </div>
    </div>
</template>

<script>
import productCreateNewProduct from './createProduct.vue';
import productAttributesVue from './productAttributes.vue';
import productListVue from './productList.vue';
import productGroupOverviewVue from './productGroupOverview.vue';
import productListItemEditVue from './productListItemEdit.vue';

export default {
    components: {
        createNewProdBlock: productCreateNewProduct,
        productAttributes: productAttributesVue,
        productList: productListVue,
        productGroupOverview: productGroupOverviewVue,
        productListItemEdit: productListItemEditVue
    },
    data() {
        return {
            selectedMenu: 'productList',
            selectedProductGroupForOverview: null,
            selectedProductForEdit: null,
        }
    },
    watch: {
        selectedMenu(newVal, oldVal) {
            if (newVal != 'productOverview' && this.selectedProductGroupForOverview != null) {
                this.selectedProductGroupForOverview = null;
            } else if (newVal != 'productEdit' && this.selectedProductForEdit != null) {
                this.selectedProductForEdit = null;
            }
        },
    }
}
</script>

<style>

</style>